import { useEffect, useMemo, useState } from "react";
import { Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import BackButton from "../../components/CustomButton/BackButton";
import { getAllDealsList, getDealInterestInvestors } from "../../redux/slices/DealApprovalSlice";
import "./JointVenturesViewDetails.scss";
import DealOverview from "./DealOverview";
import FeedbackTable from "./FeedbackTable";

const JointVenturesViewDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { allDealsList = [], dealInterestInvestors } = useSelector(
    (state) => state.dealApproval || {},
  );
 const [activeTab, setActiveTab] = useState("overview");
  const dealDataFromState = location?.state?.dealData || null;
  const dealIdFromState = location?.state?.dealId;
  const dealIdFromQuery = new URLSearchParams(location?.search || "").get(
    "dealId",
  );
  const selectedDealId =
    dealDataFromState?.dealId || dealIdFromState || dealIdFromQuery;

  useEffect(() => {
    if (!selectedDealId) return;
    dispatch(getAllDealsList());
  }, [dispatch, selectedDealId]);

  const effectiveDeal = useMemo(() => {
    const matched = Array.isArray(allDealsList)
      ? allDealsList.find(
          (deal) => String(deal?.dealId) === String(selectedDealId),
        )
      : null;
    return matched || dealDataFromState || {};
  }, [allDealsList, dealDataFromState, selectedDealId]);

  useEffect(() => {
    if(activeTab !== "overview"){
      dispatch(getDealInterestInvestors({ dealId: selectedDealId, interestStatus: activeTab }));
    }
  }, [activeTab, dispatch, selectedDealId]);

  return (
    <>
      <BackButton />
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: "overview",
            label: "Deal Overview",
            children: <DealOverview deal={effectiveDeal} />,
          },
          {
            key: "Neutral",
            label: `Neutral`,
            children: (
              <FeedbackTable
                data={dealInterestInvestors}
                activeTab={activeTab}
                dealId={selectedDealId}
              />
            ),
          },
          {
            key: "Not Interested",
            label: `Not Interested`,
            children: (
              <FeedbackTable
                data={dealInterestInvestors}
                activeTab={activeTab}
                dealId={selectedDealId}
              />
            ),
          },
          {
            key: "Request more info",
            label: `Request more info`,
            children: (
              <FeedbackTable
                data={dealInterestInvestors}
                activeTab={activeTab}
                dealId={selectedDealId}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default JointVenturesViewDetails;
